import Vue from 'vue';

/**
 * Vue's nextTick: the callback runs, and the promise resolves, after Vue has applied the pending changes to the DOM.
 *
 * Use this instead of the `nextTick` of `@vue/composition-api`: in the version used here (0.6.7) that one returns a bound function
 * without calling it, so a callback never runs and `await nextTick()` does not wait for the DOM.
 */
export const nextTick = (callback?: () => void): Promise<void> => {
    const ticked = Vue.nextTick();
    // The promise also waits for the callback.
    return callback ? ticked.then(callback) : ticked;
};
